exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ul, li {\n    list-style: none;\n}\n\n.btn-streamspot {\n    color: #333;\n    background-color: #fff;\n    border-color: #ccc;\n}\n.broadcast-button, .broadcast-meta {\n    font-size: 87%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/css/upcoming-broadcasts.css
// module id = 354
// module chunks = 2 3 5 7